/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Session_Minutes_LongInputs */

const en_us2_intake_why_session_minutes_long = /** @type {(inputs: Intake_Why_Session_Minutes_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercises are added until the time is full, compounds first.`)
};

const pt_br2_intake_why_session_minutes_long = /** @type {(inputs: Intake_Why_Session_Minutes_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercícios entram até o tempo acabar, compostos primeiro.`)
};

const es_419_intake_why_session_minutes_long = /** @type {(inputs: Intake_Why_Session_Minutes_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se agregan ejercicios hasta llenar el tiempo, los compuestos primero.`)
};

const pt_pt2_intake_why_session_minutes_long = /** @type {(inputs: Intake_Why_Session_Minutes_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os exercícios entram até o tempo acabar, os compostos primeiro.`)
};

const fr_fr2_intake_why_session_minutes_long = /** @type {(inputs: Intake_Why_Session_Minutes_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les exercices sont ajoutés jusqu'à remplir le temps, polyarticulaires d'abord.`)
};

const de_de2_intake_why_session_minutes_long = /** @type {(inputs: Intake_Why_Session_Minutes_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen kommen hinzu, bis die Zeit voll ist, Grundübungen zuerst.`)
};

const it_it2_intake_why_session_minutes_long = /** @type {(inputs: Intake_Why_Session_Minutes_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli esercizi si aggiungono finché il tempo non è pieno, prima i multiarticolari.`)
};

/**
* | output |
* | --- |
* | "Exercises are added until the time is full, compounds first." |
*
* @param {Intake_Why_Session_Minutes_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_session_minutes_long = /** @type {((inputs?: Intake_Why_Session_Minutes_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Session_Minutes_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_session_minutes_long(inputs)
	if (locale === "es-419") return es_419_intake_why_session_minutes_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_session_minutes_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_session_minutes_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_session_minutes_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_session_minutes_long(inputs)
	return en_us2_intake_why_session_minutes_long(inputs)
});
export { intake_why_session_minutes_long as "intake.why.session_minutes.long" }